module.exports = __webpack_public_path__ + "img/icon-admin-blue.6cb23388.svg";